import { ASSET_FIELD } from './custom-chart/spec-chart-render';
import type { VisualSummaryRow } from './types';

/**
 * A Visual Summary bar's category label: the row's DIMENSION values — every field except the
 * metric `value` — joined with ` / `, or an em dash when it has none. Read off the row's OWN
 * fields (not the current Group-by keys), so a label stays right through a
 * `keepPreviousData` transition, where the rows can still be the prior grouping's. An Asset
 * that names a Tract the package holds in part is followed by its "(N of M Subtracts)".
 *
 * @param {VisualSummaryRow} row - One ranked row.
 * @param {Function} nameForAsset - An Asset as the tables name it (`usePartialTracts().nameForAsset`).
 * @return {string} The label, before word-wrapping.
 */
export function categoryLabel(
  row: VisualSummaryRow,
  nameForAsset: (name: string) => string
): string {
  return (
    Object.entries(row)
      .filter(([key]) => key !== 'value')
      .map(([key, value]) => {
        const text = String(value ?? '');
        return key === ASSET_FIELD ? nameForAsset(text) : text;
      })
      .filter(Boolean)
      .join(' / ') || '—'
  );
}
